import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import HttpRoute from "../../../dce-ajax/lib/utils/HttpRoute";
import {DceAjax} from "dce-ajax";

interface AutoSaveFragmentProps {
    call: string;
}

@Dce("AutoSaveFragment")
export default class AutoSaveFragment extends DceComponent<AutoSaveFragmentProps> {

    private route: HttpRoute;
    private cont: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: AutoSaveFragmentProps) {
        super(elem, props);
        this.route = HttpRoute.of(this.props.call);

        this.cont = $(this.elem);

        elem.addEventListener('change', ev => {
            this.change(ev);
        })
    }

    private removeErrors(){
        this.cont.find('.error').removeClass('error');
    }

    public change(e:Event){

        console.log("CHANGE EVENT");

        let changeElem = e.target as HTMLElement;
        let changedName = changeElem.getAttribute('name');

        let serialized = $(this.elem).find('input, textarea, select').serialize();

        console.log("SER", serialized);

        DceAjax.getInstance()
            .post(this.route.build(changedName), serialized)
            .then(res => {
                console.log("RESULT", res);

                if(res.hasData("form")){

                    let formData = res.getData("form") as FormDataResp[];
                    this.removeErrors();

                    for (let d of formData) {

                        if(d.error){
                            this.cont.find('*[name=' + d.name + ']').addClass('error');
                        }

                        if(d.value != undefined) {
                            this.cont.find('*[name=' + d.name + ']').val(d.value);
                        }

                    }
                }

            });

    }

}

interface FormDataResp {
    name: string;
    error?: boolean;
    value?: string;
}
